import { render, staticRenderFns } from "./ComponentPaginator.vue?vue&type=template&id=400d2eec&scoped=true&"
import script from "./ComponentPaginator.vue?vue&type=script&lang=js&"
export * from "./ComponentPaginator.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPaginator.vue?vue&type=style&index=0&id=400d2eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d2eec",
  null
  
)

export default component.exports